import { LitEntity, html, css } from '../../utility/lit-entity';
import { sharedStyles } from '../../styles/shared-styles';
import '../../common/bn-action';

class UpdateOrganization extends LitEntity {
  static get styles() {
    return [sharedStyles, css`
      :host {
        display: block;
      }
    `];
  }

  render() {
    return html`
      <bn-action
        .href=${this.href}
        actionname="update-organization"
        submittext="Update"
        buttonstyle="outlined"
        successtext="Organization has been updated."
        errortext="Could not update organization."
      >
      </bn-action>
    `;
  }
}

window.customElements.define('update-organization', UpdateOrganization);
